import { CheckboxChecked, CheckboxEmpty, CheckboxIndeterminate } from '@ori-ui/icons';
import { checkboxClasses } from '@ori-ui/mui-bundle/material';
import { colors } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  root: {
    color: colors.defaultColors.dark,
    '&:hover': {
      backgroundColor: colors.oriGrey[100]
    },
    [`&.${checkboxClasses.checked}`]: {
      color: colors.defaultColors.dark
    },
    [`&.${checkboxClasses.checked}.${checkboxClasses.disabled}`]: {
      color: colors.oriGrey[400]
    }
  }
};
const defaultProps = {
  icon: /*#__PURE__*/_jsx(CheckboxEmpty, {}),
  indeterminateIcon: /*#__PURE__*/_jsx(CheckboxIndeterminate, {}),
  checkedIcon: /*#__PURE__*/_jsx(CheckboxChecked, {}),
  color: 'inputElements'
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiCheckbox.js.map